<template>
  <table
    ref="table"
    class="table">
    <thead>
      <tr>
        <th
          v-for="(col, idx) in headColumns"
          :key="idx"
          :style="col.style"
        >
          <span>
            {{ col.text }}
          </span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(row, idx) in rows"
        :key="idx"
        :ref="`tr-${idx}`"
        @click="toggleHead(`tr-${idx}`)"
      >
        <td
          v-for="(item, itemIdx) in row"
          :key="itemIdx"
          :style="itemIdx > 0 ? headColumns[itemIdx].style : null"
        >
          <div class="head">
            <span>
              <i
                v-if="itemIdx === 0"
                class="fas fa-angle-right"
              />
              {{ item.head.text }}
            </span>
          </div>
          <div class="body">
            <p
              v-for="(body, bodyIndex) in item.body"
              :key="bodyIndex"
              :ref="`tr-${idx}-p-${bodyIndex}`"
              :class="`tr-${idx}-p-${bodyIndex} sku-id-${rows[idx][0].body[bodyIndex].id} limit-line`"
              style="height: auto; padding: 0; display: flex; flex-direction: column;"
              @click="toggleBody(`tr-${idx}-p-${bodyIndex}`, rows[idx][0].body[bodyIndex].id)"
              @mouseover="handleMouseover(`tr-${idx}-p-${bodyIndex}`)"
              @mouseleave="handleMouseleave(`tr-${idx}-p-${bodyIndex}`)"
            >
              <span
                :style="{
                  'padding': `2px 0 2px ${itemIdx === 0 ? '25px' : '10px'}`
                }"
              >
                <template v-if="itemIdx === 0">
                  <i
                    v-if="isRender && details[`sku-id-${rows[idx][0].body[bodyIndex].id}`] && details[`sku-id-${rows[idx][0].body[bodyIndex].id}`].loading"
                    class="fas fa-spinner spin"
                  />
                  <i
                    v-else
                    class="fas fa-angle-right"
                  />
                </template>
                {{ body.text }}
              </span>
              <template v-if="isRender && details[`sku-id-${rows[idx][0].body[bodyIndex].id}`]">
                <span
                  v-for="(detail, detailIndex) in details[`sku-id-${rows[idx][0].body[bodyIndex].id}`].data"
                  :key="detailIndex"
                  :ref="`tr-${idx}-p-${bodyIndex}-span-${detailIndex}`"
                  :style="{
                    'padding': `2px 0 2px ${itemIdx === 0 ? '25px' : '10px'}`
                  }"
                  :class="`tr-${idx}-p-${bodyIndex}-span-${detailIndex} sub-body`"
                  @mouseover="handleMouseover(`tr-${idx}-p-${bodyIndex}-span-${detailIndex}`, 'bg-light-2')"
                  @mouseleave="handleMouseleave(`tr-${idx}-p-${bodyIndex}-span-${detailIndex}`, 'bg-light-2')">
                  <span
                    v-if="itemIdx === 0"
                    style="padding: 2px 0 2px 0;">
                    &nbsp;
                  </span>
                  <span
                    v-else
                    style="padding: 2px 0 2px 0;">
                    {{ detail[pickKeys[itemIdx]] != null ? getNumber(detail[pickKeys[itemIdx]]) : '&nbsp;' }}
                  </span>
                </span>
              </template>
            </p>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'BaseTableCollapse',

  props: ['headColumns', 'rows', 'pickKeys'],

  data() {
    return {
      isRender: true,
      isClickedBody: false,
      details: {
        // 'sku-id-66fcf0a9aa32327609d4ad05': [
        //   {
        //     '_id': '66f121ab78122b3b0fed2c87',
        //     'cost': 70,
        //     'discount': 0,
        //     'tax': 0,
        //     'collect': 100,
        //     'refund': 0,
        //     'net': 100,
        //     'profit': 30,
        //     'ps_id': '66f12189db0ee5389b803f19',
        //     'ps_code': 'POS/STORE/2024/09/23/01',
        //     'posbi_id': '66f121abdb0ee5389b803fd2',
        //     'posbio_id': '66f121abdb0ee5389b803fd4',
        //     'cashier_id': '66f1213bdb0ee5389b803da5',
        //     'product_id': '66f1217adb0ee5389b803eb5',
        //     'sku_id': '66f1217adb0ee5389b803eba',
        //     'cat_id': '66f12185db0ee5389b803ee5',
        //     'quantity': 1,
        //     'shop_id': '66f1213bdb0ee5389b803da7',
        //     'created_at': '2024-09-23T08:07:07.340Z',
        //     '__v': 0,
        //     'customer': 'Customer A',
        //   },
        //   {
        //     '_id': '66fceef9840f092259cd9716',
        //     'cost': 70,
        //     'discount': 0,
        //     'tax': 0,
        //     'collect': 200,
        //     'refund': 0,
        //     'net': 200,
        //     'profit': 60,
        //     'ps_id': '66fceeebaa32327609d4aa5b',
        //     'ps_code': 'POS/STORE/2024/10/02/01',
        //     'posbi_id': '66fceef9aa32327609d4aa96',
        //     'posbio_id': '66fceef9aa32327609d4aa98',
        //     'cashier_id': '66f1213bdb0ee5389b803da5',
        //     'product_id': '66f1217adb0ee5389b803eb5',
        //     'sku_id': '66f1217adb0ee5389b803eba',
        //     'cat_id': '66f12185db0ee5389b803ee5',
        //     'quantity': 2,
        //     'shop_id': '66f1213bdb0ee5389b803da7',
        //     'created_at': '2024-10-02T06:58:01.493Z',
        //     '__v': 0,
        //     'customer': 'Customer A',
        //   },
        //   {
        //     '_id': '66fcefdc840f092259cd9730',
        //     'cost': 70,
        //     'discount': 0,
        //     'tax': 0,
        //     'collect': 100,
        //     'refund': 0,
        //     'net': 100,
        //     'profit': 30,
        //     'ps_id': '66fceeebaa32327609d4aa5b',
        //     'ps_code': 'POS/STORE/2024/10/02/01',
        //     'posbi_id': '66fcefdcaa32327609d4abe6',
        //     'posbio_id': '66fcefdcaa32327609d4abe8',
        //     'cashier_id': '66f1213bdb0ee5389b803da5',
        //     'product_id': '66f1217adb0ee5389b803eb5',
        //     'sku_id': '66f1217adb0ee5389b803eba',
        //     'cat_id': '66f12185db0ee5389b803ee5',
        //     'quantity': 1,
        //     'shop_id': '66f1213bdb0ee5389b803da7',
        //     'created_at': '2024-10-02T07:01:48.850Z',
        //     '__v': 0,
        //     'customer': 'Customer B',
        //   },
        // ],
      },
    }
  },

  methods: {
    toggleHead (ref) {
      if (this.isClickedBody) {
        return
      }
      this.$refs[ref][0].classList.toggle('active')
    },
    toggleBody(ref, skuId) {
      const isActived = this.$refs[ref][0].className.search('active') >= 0

      // wait response data and set ui
      if (!isActived) {
        const key = `sku-id-${skuId}`
        this.details[key] = {}
        this.details[key].loading = true

        // force components to rerender
        this.isRender = false
        this.$nextTick(() => {
          this.isRender = true
        })

        this.$emit('onGetDetails', skuId, (data) => {
          this.details[key].loading = false
          this.details[key].data = data
          this.details[key].loaded = true

          // force components to rerender
          this.isRender = false
          this.$nextTick(() => {
            this.isRender = true
          })
        })
      }

      /**
       * set ui
       */
      this.$refs[ref].forEach((el) => {
        el.classList.toggle('active')
      })

      this.isClickedBody = true
      const that = this
      setTimeout(function() {
        that.isClickedBody = false
      }, 500)
    },
    handleMouseover (className, bgName = 'bg-light') {
      const elements = this.$refs.table.querySelectorAll(`.${className}`)
      elements.forEach((ele) => {
        ele.classList.add(bgName)
      })
    },
    handleMouseleave (className, bgName = 'bg-light') {
      const elements = this.$refs.table.querySelectorAll(`.${className}`)
      elements.forEach((ele) => {
        ele.classList.remove(bgName)
      })
    },
  },
}
</script>

<style scoped>
tr th, tr td {
  padding-left: 0;
  padding-right: 0;
}

tr span, tr p {
  padding-left: 10px;
  padding-right: 10px;
}

tbody tr {
  cursor: pointer;
}

tr .body {
  display: none;
  margin-top: 6px;
  margin-bottom: 2px;
}

tr td:first-of-type .body p {
  padding-left: 24px;
}

tr .body p {
  padding-top: 2px;
  padding-bottom: 2px;
  margin: 0;
  height: 25px;
  max-width: 600px;
}

tr .head i {
  margin-right: 2px;
}

tr.active .body {
  display: block;
}

tr.active .head i {
  transform: rotate(90deg);
}

.bg-light {
  background-color: tan;
}

.body p .sub-body {
  display: none;
}

.body p.active .sub-body {
  display: block;
}

.body p.active .fa-angle-right {
  transform: rotate(90deg);
}

.bg-light-2 {
  background-color: #e8e8e8;
}

.limit-line {
  display: inline-block;
  width: 99.99%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseTableCollapseNested.vue